// extracted by mini-css-extract-plugin
export default {"ProjectList":"ProjectList_ProjectList__gDd3W"};